export default __webpack_public_path__ + "static/media/lumen_Infinity_241px.6c11fb11.gif";